import { DisplayTime } from './DisplayTime';
import { DisplayTimezone } from './DisplayTimezone';
import { DisplayTimeDiff } from './DisplayTimeDiff';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import '../styles/TimezoneList.css';

export function TimezoneList({
  timezones,
  local_timezone,
  is24hFormat,
  currentTime,
  onRemoveTimezone,
  onEditTimezone,
  onReorderTimezones,
}) {
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedTimezones = [...timezones];
    const [removed] = reorderedTimezones.splice(result.source.index, 1);
    reorderedTimezones.splice(result.destination.index, 0, removed);

    onReorderTimezones(reorderedTimezones);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="timezone-list">
        {(provided) => (
          <div
            className="table-responsive"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            <table className="table table-sm">
              <tbody>
                {timezones.map((timezone, index) => (
                  <Draggable key={timezone.id} draggableId={timezone.id} index={index}>
                    {(provided, snapshot) => (
                      <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`timezone-row ${snapshot.isDragging ? 'dragging' : ''}`}
                      >
                        <td><h6 className="mb-0">{timezone.display_name}</h6></td>
                        <td><h6 className="mb-0"><DisplayTime timezone={timezone.tz_string} is24hFormat={is24hFormat} currentTime={currentTime} /></h6></td>
                        <td><h6 className="mb-0"><DisplayTimezone timezone={timezone.tz_string} /></h6></td>
                        <td><h6 className="mb-0"><DisplayTimeDiff timezone={timezone.tz_string} local_timezone={local_timezone} /></h6></td>
                        <td className="text-end" style={{ width: '150px' }}>
                          <div className="d-flex justify-content-end align-items-center">
                            <button
                              className="btn btn-light btn-sm"
                              onClick={() => onEditTimezone(timezone)}
                              aria-label="Edit Timezone"
                            >
                              ✎
                            </button>
                            <button
                              className="btn btn-light btn-sm ml-2"
                              onClick={() => onRemoveTimezone(timezone.id)}
                              aria-label="Remove Timezone"
                            >
                              &times;
                            </button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </tbody>
            </table>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}